var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInfoTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C4EC1;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_350",
    transform: "translate(-1645.625 -1370.228)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_13",
    className: "st0",
    cx: 1658,
    cy: 1382,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    id: "info_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    className: "st1",
    d: "M1656.43,1388.23h2.4v-7.2h-2.4V1388.23z M1657.63,1378.63 c0.32,0.01,0.63-0.12,0.85-0.34c0.23-0.23,0.35-0.53,0.34-0.85c0.01-0.32-0.12-0.63-0.34-0.85c-0.23-0.23-0.53-0.35-0.85-0.35 c-0.32-0.01-0.63,0.12-0.85,0.34c-0.23,0.23-0.35,0.53-0.34,0.85c-0.01,0.32,0.12,0.63,0.34,0.85 C1657,1378.51,1657.3,1378.64,1657.63,1378.63z M1657.63,1394.23c-1.61,0.01-3.2-0.31-4.68-0.95c-1.42-0.6-2.71-1.47-3.81-2.56 c-1.09-1.09-1.96-2.39-2.57-3.81c-0.63-1.48-0.96-3.07-0.94-4.68c-0.01-1.61,0.31-3.2,0.94-4.68c0.6-1.42,1.47-2.72,2.57-3.81 c1.09-1.09,2.39-1.96,3.81-2.57c1.48-0.63,3.07-0.96,4.68-0.94c1.61-0.01,3.2,0.31,4.68,0.94c1.42,0.6,2.72,1.47,3.81,2.57 c1.09,1.09,1.96,2.39,2.57,3.81c0.63,1.48,0.96,3.07,0.94,4.68c0.01,1.61-0.31,3.2-0.94,4.68c-0.6,1.42-1.47,2.72-2.57,3.81 c-1.09,1.09-2.39,1.96-3.81,2.56C1660.83,1393.92,1659.23,1394.24,1657.63,1394.23z M1657.63,1391.83 c2.56,0.05,5.02-0.96,6.81-2.79c1.83-1.79,2.84-4.25,2.79-6.81c0.05-2.56-0.96-5.02-2.79-6.81c-1.79-1.83-4.25-2.84-6.81-2.79 c-2.56-0.05-5.02,0.96-6.81,2.79c-1.83,1.79-2.84,4.25-2.79,6.81c-0.05,2.56,0.96,5.02,2.79,6.81 C1652.6,1390.87,1655.07,1391.88,1657.63,1391.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoTags);
export default __webpack_public_path__ + "static/media/ico_info_tags.bc547c46eca437ca7f1bff64859cc27e.svg";
export { ForwardRef as ReactComponent };